import React from 'react';
import { useTheme } from 'styled-components';

export const GreenTickSvg = (props) => {
  const { width, height, color } = props;

  const theme = useTheme();

  return (
    <svg width={width ?? "14"} height={height ?? "10"} viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.3334 1L5.00008 8.33333L1.66675 5" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}